export let changeFolderCountText = "kE8lXd";
export let showUnreadCountText = "gFDYtb";
export let showTotalCountText = "n8imhb";
export default {changeFolderCountText,showUnreadCountText,showTotalCountText};